export default "__VITE_ASSET__D$g1OLoj__"